export default __webpack_public_path__ + "static/media/Raíssa Guimarães_.7ee510cc.png";